import * as Vuex from "vuex";
import { Storage } from "@/entities/storage";
import { httpByCurrentCustomer } from "@/lib/client";

export type CreateStorage = {
  nameBucket: string;
  providerName: string;
  accessKey?: string;
  Secret?: string;
  region?: string;
  credentialFile?: string;
  sftpUsername?: string;
  sftpHostname?: string;
  sftpPort?: number;
  sftpDirectory?: string;
};
const StorageModule: Vuex.Module<StoragekStoreState, {}> = {
  state: {
    listStorage: [], //Donde se guardara la consulta de los buckets
    sftpResponse: [], //Respuesta al agregar SFTP
  },
  getters: {
    storageTable(state) {
      return state.listStorage;
    },
    sftpResponse(state) {
      return state.sftpResponse;
    },
  },
  mutations: {
    SET_STORAGE_TABLE(state, payload: Storage[]) {
      state.listStorage = payload;
    },
    REMOVE_STORAGE_ITEM(state, id: string) {
      state.listStorage = state.listStorage.filter((t) => t.id != id);
    },
    SET_SFTPRESPONSE(state, payload: Storage[]) {
      state.sftpResponse = payload;
    },
  },
  actions: {
    async getAllStorage({ commit }) {
      const responseStorage = await httpByCurrentCustomer()
        .get("storage")
        .json<Storage[]>();
      if (Array.isArray(responseStorage)) {
        commit("SET_STORAGE_TABLE", responseStorage);
      }
    },
    async deleteStorage({ commit }, StorageDeletedRequest: any) {
      await httpByCurrentCustomer()
        .delete(`storage`, { json: StorageDeletedRequest })
        .json<null>()
        .then(() => {
          commit("REMOVE_STORAGE_ITEM", StorageDeletedRequest.storageId);
        });
    },
    async verifyStorage({ commit }, payload: CreateStorage) {
      await httpByCurrentCustomer()
        .post("storage/verify", { json: payload })
        .json<CreateStorage>();
    },
    async createStorage({ commit }, payload: CreateStorage) {
      const response = await httpByCurrentCustomer()
        .post("storage", { json: payload })
        .json<CreateStorage>();
      commit("SET_SFTPRESPONSE", response);
    },
  },
  namespaced: true,
};

type StoragekStoreState = {
  listStorage: Storage[];
  sftpResponse: Storage[];
};
export default StorageModule;
